import './App.css';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import { Dashboard } from './components/Dashboard';
import { Error } from './components/Error';
import {Login} from './components/Login';
import { useDispatch } from 'react-redux';
import { setUser } from './slices/loginSlice';
import { ItemDetails } from './components/ItemDetails';
import { ItemCreate } from './components/ItemCreate';
import { SignUp } from './components/SignUp';
import { UserProfile } from './components/UserProfile';
import { Activities } from './components/Activities';
import { Browse } from './components/Browse';
import { Popular } from './components/Popular';
import { PendingItems } from './components/admin/PendingItems';
import { Admin } from './components/admin/Admin';
import { CreateItemUpdate } from './components/CreateItemUpdate';
import { ItemUpdate } from './components/ItemUpdate';
import { UserValidation } from './components/UserValidation';
import {v4 as uuidv4} from 'uuid';
import { ForgotPassword } from './components/ForgotPassword';
import { Sandbox } from './components/Sandbox';
import { ShareExperience } from './components/ShareExperience';
import { Tag } from './components/Tag';
import { SiteTickets } from './components/site-tickets/SiteTickets';
import { Shop } from './components/shop/Shop';
import { PrivacyPolicy } from './components/PrivacyPolicy';

const App = () => {

  const dispatch = useDispatch();
  const user = window.localStorage.getItem('user') ? JSON.parse(window.localStorage.getItem('user')) : null;
  if (user) {
    dispatch(setUser(user))
  }
  if (!window.localStorage.getItem("device_id")) {
    window.localStorage.setItem('device_id', uuidv4());
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Activities />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/popular" element={<Popular />} />
        <Route path="/browse" element={<Browse />} />
        <Route path="/login" element={<Login />} />
        <Route path="/items/:itemId" element={<ItemDetails />} />
        <Route path="/create-item" element={<ItemCreate />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/user/:userId/:section" element={<UserProfile />} />
        <Route path="/create-item-update/:itemId/:property" element={<CreateItemUpdate />} />
        <Route path="/item-update/:itemUpdateId" element={<ItemUpdate />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/validation" element={<UserValidation />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/sandbox" element={<Sandbox />} />
        <Route path="/share-experience/:itemId" element={<ShareExperience />} />
        <Route path="/share-experience/:itemId/:action" element={<ShareExperience />} />
        <Route path="/tags/:tag" element={<Tag />} />
        <Route path="/site-tickets" element={<SiteTickets />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </Layout>
  );
}

export default App;
